// Artifact: 1, // Artifacts in all channels
// LeadOff: 0.33, // Lead off on diagnosis channel
// LeadOff2: 1, // More than one lead disconnected
// LeadOff3: 1, // All leads or ECG cable disconnected
// LeadOffLL: 0.66, // Lead LL disconnected
// LeadOffLA: 0.66, // Lead LA disconnected
// LeadOffRA: 0.66, // Lead RA disconnected
// MissingStrips: 0.5,
// Offline: 1, // The device has been offline for more than 12 hours

import { WirelessSignalLevel, flagStudySolution } from '@/shared/ui/assets/png';

const FLAGGED_REASON = {
  PENDING_UPLOAD: 'PENDING_UPLOAD',
};

const BIOFLUX_ARTIFACT_FINDINGS = [
  {
    text: 'Artifact',
    issue: 'Artifacts in all channels',
    description:
      "All leads are disconnected from the electrodes, or the electrodes no longer stick firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all ECG leads with the patient and ensure all electrodes firmly stick to the patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOff',
    issue: 'Lead off on diagnosis channel',
    description:
      "The diagnosis channel is off. This can be from the lead is disconnected from the electrode, or the electrode no longer sticks firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all ECG leads with the patient and ensure all electrodes firmly stick to the patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOff2',
    issue: 'More than one lead disconnected',
    description:
      "More than one lead is disconnected from the electrodes, or the electrodes no longer stick firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all ECG leads with the patient and ensure all electrodes firmly stick to the patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOff3',
    issue: 'All leads or ECG cables disconnected',
    description:
      "All leads are disconnected from the electrodes, or the electrodes no longer stick firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all ECG leads with the patient and ensure all electrodes firmly stick to the patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOffLL',
    issue: 'Lead LL disconnected',
    description:
      "One of the 3 ECG leads - lead LL is disconnected from the electrode, or the electrode no longer sticks firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all ECG leads with the patient and ensure all electrodes firmly stick to the patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOffLA',
    issue: 'Lead LA disconnected',
    description:
      "One of the 3 ECG leads - lead LA is disconnected from the electrode, or the electrode no longer sticks firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all ECG leads with the patient and ensure all electrodes firmly stick to the patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOffRA',
    issue: 'Lead RA disconnected',
    description:
      "One of the 3 ECG leads - lead RA is disconnected from the electrode, or the electrode no longer sticks firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all ECG leads with the patient and ensure all electrodes firmly stick to the patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'MissingStrips',
    issue: '',
  },
  {
    text: 'Offline',
    issue: 'The device has been offline for more than 12 hours',
    description:
      'The device has been offline for more than 12 hours. It may be powered off by the patient, or it was out of battery, or the issue was due to low cell coverage.',
    stepsToTry: [
      {
        order: 1,
        content: 'Call the patient.',
        isPatientInfo: true,
      },
      {
        order: 2,
        content: 'Ensure that the device is powered on and has sufficient charge.',
      },
      {
        order: 3,
        content:
          'Check if the WIRELESS SIGNAL LEVEL indicator to see if there is a low cell coverage issue with the device.',
        image: WirelessSignalLevel,
        subContent: [
          'If the cell signal level is low, bring the device near to window to see if the cell signal level is increased.',
          'If the cell signal level is good but the device is still offline, issue an RMA for this device.',
        ],
      },
    ],
  },
  {
    text: 'Paused',
    issue: 'The study has been paused for more than 8 hours',
    description:
      'The study has been paused for more than 8 hours. The patient might put off the device for charging and forgot to wear it back to continue the study.',
    stepsToTry: [
      {
        order: 1,
        content: 'Call the patient.',
        isPatientInfo: true,
      },
      {
        order: 2,
        content: 'Instruct the patient to wear the device properly to continue the study.',
      },
    ],
  },
  {
    text: FLAGGED_REASON.PENDING_UPLOAD,
    issue: 'Data upload pending due to offline device',
    description:
      'The study duration has ended, but data upload is pending because the device has been offline for more than 6 hours. It may be powered off by the patient, or it was out of battery, or the issue was due to low cell coverage.',
    stepsToTry: [
      {
        order: 1,
        content: 'Call the patient to check on the device.',
        isPatientInfo: true,
      },
      {
        order: 2,
        content: 'Ensure the device is powered on and fully charged.',
      },
      {
        order: 3,
        content:
          'Check if the WIRELESS SIGNAL LEVEL indicator to see if there is low cell coverage issue with the device.',
        image: WirelessSignalLevel,
        subContent: [
          'If the cell signal level is low, bring the device near to window to see if the cell signal level is increased.',
          'If the cell signal level is good but the device is still offline, issue an RMA for this device.',
        ],
      },
      {
        order: 4,
        content:
          'Check the device status in the portal. Review the progress bar to confirm if the upload has resumed.',
      },
    ],
  },
];

const BIOTRES_ARTIFACT_FINDINGS = [
  {
    text: 'Artifact',
    issue: 'Artifacts in all channels',
    description:
      "All electrodes are disconnected, or the electrode pads no longer stick firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all electrodes with the patient and ensure all electrode pads firmly stick to patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOff',
    issue: 'Lead off on diagnosis channel',
    description:
      "Diagnosis channel is off. This can be from the disconnection of electrodes, or the electrode pads no longer sticks firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all electrodes with the patient and ensure all electrode pads firmly stick to patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOff2',
    issue: 'More than one electrode disconnected',
    description:
      "More than one electrode is disconnected, or the electrode pads no longer stick firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all electrodes with the patient and ensure all electrode pads firmly stick to patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOff3',
    issue: 'All electrodes disconnected',
    description:
      "All electrodes are disconnected, or the electrode pads no longer stick firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all electrodes with the patient and ensure all electrode pads firmly stick to patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOffLL',
    issue: 'LL electrode disconnected',
    description:
      "One of the 3 electrodes - LL is disconnected, or the electrode pad no longer sticks firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all electrodes with the patient and ensure all electrode pads firmly stick to patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOffLA',
    issue: 'LA electrode disconnected',
    description:
      "One of the 3 electrodes - LA is disconnected, or the electrode pad no longer sticks firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all electrodes with the patient and ensure all electrode pads firmly stick to patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'LeadOffRA',
    issue: 'RA electrode disconnected',
    description:
      "One of the 3 electrodes - RA is disconnected, or the electrode pad no longer sticks firmly to the patient's skin.",
    stepsToTry: [
      {
        order: 1,
        content: 'Verify the current signal by getting an evaluation strip.',
      },
      {
        order: 2,
        content: 'If the issue is confirmed, call the patient.',
        isPatientInfo: true,
      },
      {
        order: 3,
        content:
          "Check all electrodes with the patient and ensure all electrode pads firmly stick to patient's skin.",
      },
      {
        order: 4,
        content: 'Verify the signal again by getting an evaluation strip.',
      },
    ],
  },
  {
    text: 'MissingStrips',
    issue: '',
  },
  {
    text: 'Offline',
    issue: 'The device has been offline for more than 12 hours',
    description:
      'The device has been offline for more than 12 hours. It may be powered off by the patient, or it was out of battery, or the issue was due to no internet connection.',
    stepsToTry: [
      {
        order: 1,
        content: 'Call the patient.',
        isPatientInfo: true,
      },
      {
        order: 2,
        content: 'Ensure that the device is powered on and has sufficient charge.',
      },
      {
        order: 3,
        content: 'Check the internet connection on the phone:',
        subContent: [
          "If there is no signal, reset the phone's network settings.",
          'If network connection is good but the device is still offline, issue an RMA for this device.',
        ],
      },
    ],
  },
  {
    text: 'Paused',
    issue: 'The study has been paused for more than 8 hours',
    description:
      'The study has been paused for more than 8 hours. The patient might put off the device for charging and forgot to wear it back to continue the study.',
    stepsToTry: [
      {
        order: 1,
        content: 'Call the patient.',
        isPatientInfo: true,
      },
      {
        order: 2,
        content: 'Instruct the patient to wear the device properly to continue the study.',
      },
    ],
  },
  {
    text: FLAGGED_REASON.PENDING_UPLOAD,
    issue: 'Data upload pending due to offline device',
    description:
      'The study duration has ended, but the data upload is still pending because the device has been offline for more than 6 hours. This may happen if the device is powered off, has a low battery, or lacks an internet connection.',
    stepsToTry: [
      {
        order: 1,
        content: 'Call the patient to check on the device.',
        isPatientInfo: true,
      },
      {
        order: 2,
        content: 'Ensure the device is powered on and fully charged.',
      },
      {
        order: 3,
        content:
          'If the device still does not appear online in the portal, confirm if it is connected to the Biocare Health app.',
        isCustomSubContent: true,
        subContent: [
          {
            text: 'Look for the paired icon next to the device ID - if it appears, the patient has already paired the device with the app.',
            image: flagStudySolution,
          },
          {
            text: 'If it’s not paired, guide the patient to connect the device via Bluetooth to speed up the upload. Read more here: ',
            hyperText: 'How to connect the device with the Biocare Health app',
            hyperLink: 'https://customer.biotricity.com/instruction-heart-monitoring',
          },
          {
            text: 'Tips: Ensure the patient’s phone always has Bluetooth and internet turned on, and keep the phone close to the device for a smooth upload.',
          },
        ],
      },
      {
        order: 4,
        content:
          'Check the device status in the portal. Review the progress bar to confirm if the upload has resumed.',
      },
    ],
  },
];

const BIOCORE_PRO_ARTIFACT_FINDINGS = [
  {
    text: FLAGGED_REASON.PENDING_UPLOAD,
    issue: 'Data upload pending due to offline device',
    description:
      'The study duration has ended, but the data upload is still pending because the device has been offline for more than 6 hours. This may happen if the device is powered off, has a low battery, lacks an internet connection, or is in an area with poor cell coverage.',
    stepsToTry: [
      {
        order: 1,
        content: 'Call the patient to check on the device.',
        isPatientInfo: true,
      },
      {
        order: 2,
        content: 'Ensure the device is powered on and fully charged.',
      },
      {
        order: 3,
        content:
          'If the device still does not appear online in the portal, it may be due to low cell coverage. In this case, connecting the device to the patient app via Bluetooth is recommended.',
      },
      {
        order: 4,
        content: 'Confirm if the device is connected to the Biocare Health app.',
        isCustomSubContent: true,
        subContent: [
          {
            text: 'Look for the paired icon next to the device ID - if it appears, the patient has already paired the device with the app.',
            image: flagStudySolution,
          },
          {
            text: 'If it’s not paired, guide the patient to connect the device via Bluetooth to speed up the upload. Read more here: ',
            hyperText: 'How to connect the device with the Biocare Health app',
            hyperLink: 'https://customer.biotricity.com/instruction-heart-monitoring',
          },
          {
            text: 'Tips: Ensure the patient’s phone always has Bluetooth and internet turned on, and keep the phone close to the device for a smooth upload.',
          },
        ],
      },
      {
        order: 5,
        content:
          'Check the device status in the portal. Review the progress bar to confirm if the upload has resumed.',
      },
    ],
  },
];

export {
  BIOFLUX_ARTIFACT_FINDINGS,
  BIOTRES_ARTIFACT_FINDINGS,
  BIOCORE_PRO_ARTIFACT_FINDINGS,
  FLAGGED_REASON,
};
